const $ = jQuery;
const toggleConsent = () => {
    const $consentEmail = $('.consent-email');
    const $consentPhone = $('.consent-phone');
    const $consentMarketing = $('.consent-marketing');

    if ($consentEmail.length) {
        $consentEmail.readmore(
            {
                speed: 200,
                lessLink: '<a href="#">Zwiń</a>',
                moreLink: '<a href="#">Czytaj więcej</a>',
                collapsedHeight: 23,
                beforeToggle: function (trigger, element, expanded) {
                    if (!expanded) {
                        element.addClass('consent-open');
                    } else {
                        element.removeClass('consent-open');
                    }
                }
            }
        );
    }

    if ($consentPhone.length) {
        $consentPhone.readmore(
            {
                speed: 200,
                lessLink: '<a href="#">Zwiń</a>',
                moreLink: '<a href="#">Czytaj więcej</a>',
                collapsedHeight: 23,
                beforeToggle: function (trigger, element, expanded) {
                    if (!expanded) {
                        element.addClass('consent-open');
                    } else {
                        element.removeClass('consent-open');
                    }
                }
            }
        );
    }

    if ($consentMarketing.length) {
        $consentMarketing.readmore(
            {
                speed: 200,
                lessLink: '<a href="#">Zwiń</a>',
                moreLink: '<a href="#">Czytaj więcej</a>',
                collapsedHeight: 23,
                beforeToggle: function (trigger, element, expanded) {
                    if (!expanded) {
                        element.addClass('consent-open');
                    } else {
                        element.removeClass('consent-open');
                    }
                }
            }
        );
    }
}

export { toggleConsent };